module.exports = __webpack_public_path__ + "static/img/loading.bfb6e074.gif";